/**
 * Mirrors v1's `getContentPreviewMode` (@udemy/shared-one-udemy-components) so
 * client components can detect the CMS team's `?preview_mode=true` workflow
 * for previewing unpublished Contentful changes.
 */
const PREVIEW_MODE_SEARCH_PARAM = 'preview_mode';

export function getContentPreviewMode(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(PREVIEW_MODE_SEARCH_PARAM) === 'true';
}
